<template>
  <div v-if="ready && operator">
    <div v-if="operators.length>0">
      <h4>{{operator.name}} <span class="opaque">(рег. №: {{operator.id}})</span></h4>
      <!--<dashboard></dashboard>-->
      <div class="row">
        <div class="col-lg-12" style="margin-bottom: 10px">
          <router-link :to="{name: 'guest-visit-add', params: {operatorId: operatorId}}">
            <button class="btn btn-success btn-lg">
              <i class="icon icon-left mdi mdi-plus-square"></i>
              Добавить запись
            </button>
          </router-link>
          <router-link :to="{name: 'operator-import-file', params: {operatorId: operatorId}}" tag="button"
                       class="btn btn-default btn-lg">
            <i class="icon mdi mdi-upload"></i> Импорт данных из файла XML(zip)
          </router-link>
        </div>
        <div class="col-md-12">
          <div class="panel panel-default panel-table">
            <div class="panel-body">
              <div v-if="reports && reports.length>0" class="panel-heading">
                Отчётные периоды:
                <div class="col-md-3 pull-right" v-if="reports && reports.length>5">
                  <select class="form-control input-sm" v-model="selectedReport">
                    <option selected value="">Выбрать предыдущий отчетный период</option>
                    <option v-for="report in reports.slice(5)" :value="report">
                      <span>{{report.date_start | dateFilter("DD.MM")}} - {{report.date_end | dateFilter("DD.MM.YYYY")}}г.</span>
                      <span v-if="report.status ==='Draft'">Предварительно</span>
                      <span v-else
                            style="color:green"><strong>Представлен: {{report.date_last_submit | dateFilter("DD.MM.YYYY")}} </strong></span>
                    </option>
                  </select>
                </div>
              </div>
              <div v-if="reports && reports.length>0" class="tab-container">
                <ul class="nav nav-tabs">
                  <router-link v-for="report, index in reports.slice(0, 5)" :key="report.id" to="#" tag="li"
                               active-class="none"
                               :class="{active : Number(currentReport.id) === Number(report.id) }"
                               :to="{name: 'operator-visits', query: queryGenerator({report: report.id})}">
                    <a>
                      <span v-if="report.status ==='Draft'" class="icon mdi mdi-assignment-o"></span>
                      <span v-if="report.status !=='Draft'" class="icon mdi mdi-assignment-check"></span>
                      {{report.date_start | dateFilter("DD.MM")}} - {{report.date_end | dateFilter("DD.MM.YYYY")}}г.
                      <br><span v-if="report.status ==='Draft'">Предварительно</span>
                      <span v-else
                            style="color:green"><strong>Представлен: {{report.date_last_submit | dateFilter("DD.MM.YYYY")}} </strong></span>
                    </a>
                  </router-link>
                </ul>
              </div>
              <div class="dataTables_wrapper form-inline dt-bootstrap no-footer">
                <div class="row be-datatable-header">
                  <div class="col-sm-12" style="margin-bottom: 10px">
                    <button v-if="reportIsActive" @click="submitReport" type="button"
                            class="btn btn-default btn-lg" :class="{'disabled':!reportCanSubmitted}">
                      <i class="icon mdi mdi-assignment-check"></i> Представить отчет в Минтуризма края<br>
                    </button>
                    <button class="btn btn-default btn-lg" @click="downloadXls"><i
                      class="icon mdi mdi-download">
                    </i> Загрузить отчет в формате Excel
                    </button>
                    <router-link
                      :to="{name: 'operator-reports', params: {operatorId: operatorId, reportId: currentReport.id}}"
                      v-if="this.$auth.user().is_superuser">
                      <div class="btn btn-default btn-lg pull-right"><i
                        class="icon mdi mdi-assignment"></i> Отчеты оператора
                      </div>
                    </router-link>
                  </div>
                  <div class="col-sm-12">
                    <button v-if="reportIsActive && guestVisits.length>0" @click="deleteCheckedRecords()" type="button"
                            class="btn btn-default btn-lg"
                            :class="{disabled : checkedRecords.length===0}">
                      <i class="icon mdi mdi-delete"></i> Удалить
                    </button>
                    <button v-if="reportCanBeDeleted && guestVisits.length==0" @click="deleteReport(currentReport.id)"
                            type="button"
                            class="btn btn-default btn-lg">
                      <i class="icon mdi mdi-delete"></i> <span class="text-danger">Удалить отчетный период</span>
                    </button>
                    <button v-if="reports && reports.length>0 && !reportIsActive && reportCanRestored"
                            @click="restoreReport" type="button"
                            class="btn btn-default btn-lg pull-left">
                      <i class="icon mdi mdi-undo"></i> Отозвать отчёт
                    </button>
                    <div class="input-group input-search input-group-sm col-lg-3 pull-right">
                      <input v-model="filterQuery" type="text"
                             placeholder="Быстрый поиск по Ф.И.О" class="form-control">
                      <span class="input-group-btn">
                      <button type="button" class="btn btn-default"><i class="icon mdi mdi-search"></i></button></span>
                      <span class="panel-subtitle" v-if="filterQuery" @click="filterQuery=null" style="cursor: pointer">Очистить параметры фильтра </span>
                    </div>
                  </div>
                </div>
                <div class="panel-heading panel-heading-divider text-center">
                  Список плательщиков за отчетный период с {{currentReport.date_start | dateFilter("DD.MM.YYYY")}} по {{currentReport.date_end | dateFilter("DD.MM.YYYY")}}г.
                  <span v-if="currentReport.status ==='Draft'">Не представлен в министерство.<br>
                 <span class="text-danger"> Срок представления в министерство: {{this.currentReport.last_day_to_submit| dateFilter("DD.MM.YYYY")}}г.</span></span>
                  <span
                    v-else><strong>Представлен в Министерство: {{currentReport.date_last_submit | dateFilter("DD.MM.YYYY")}} </strong></span>
                </div>
                <div class="row be-datatable-body">
                  <div class="col-sm-12">
                    <table class="table table-striped table-hover table-fw-widget dataTable no-footer">
                      <thead>
                      <tr>
                        <th v-if="reportIsActive && guestVisits.length>0" style="width:5%;">
                          <div class="be-checkbox be-checkbox-sm">
                            <input id="check1" type="checkbox" v-model="checkAll">
                            <label for="check1"></label>
                          </div>
                        </th>
                        <th v-else>#</th>
                        <th style="width: 15%; cursor:pointer;" @click="sort('last_name')">Ф.И.О.</th>
                        <th style="cursor:pointer;" @click="sort('date_start')">Дата заезда</th>
                        <th style="cursor:pointer;" @click="sort('date_end')">Дата выезда</th>
                        <th style="width: 13%;cursor:pointer;" class="number" @click="sort('taxable_period')">
                          Количество дней <span class="mdi mdi-info"
                                                title="Количество дней фактического проживания плательщика курортного сбора, за исключением дня заезда"></span>
                        </th>
                        <th style="width: 10%;cursor:pointer;" class="number" @click="sort('tax_amount')">
                          Сумма сбора, руб.
                        </th>
                        <th style="cursor:pointer;" @click="sort('refusal_to_pay')">Отказ от оплаты</th>
                        <th style="cursor:pointer;" @click="sort('privilege_category')">Льгота</th>
                        <th style="cursor:pointer;" @click="sort('created_at')">Дата создания записи</th>
                        <th style="cursor:pointer;" @click="sort('external_id')">Unique ID <span class="mdi mdi-info"
                                                                                                 title="Уникальный id гостя в рамках объекта оператора сбора."></span>
                        </th>
                        <template v-if="reportIsActive">
                          <th></th>
                          <th></th>
                        </template>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-if="guestVisits && guestVisits.length>0" v-for="guest, index in filteredGuestVisits"
                          :key="guest.id">
                        <td v-if="reportIsActive">
                          <div class="be-checkbox be-checkbox-sm">
                            <input :id="guest.id" type="checkbox" :value="guest" v-model="checkedRecords">
                            <label :for="guest.id"></label>
                          </div>
                        </td>
                        <td v-else>{{index + 1}}</td>
                        <td>
                          <router-link v-if="reportIsActive"
                                       :to="{name: 'guest-visit-edit', params: {operatorId: operatorId, visitId: guest.id}}">
                            <a>{{get_guest_full_name(guest)}}</a>
                          </router-link>
                          <span v-else>{{get_guest_full_name(guest)}}</span>
                        </td>
                        <td>{{guest['date_start'] | dateFilter('DD.MM.YYYY')}}</td>
                        <td>{{guest['date_end'] | dateFilter('DD.MM.YYYY')}}</td>
                        <td class="number">{{guest['taxable_period'] - 1}}</td>
                        <td class="number">
                          <span v-if="guest['tax_amount']==='0.00' || guest['refusal_to_pay']">—</span>
                          <span v-else>{{guest['tax_amount']}}</span>
                        <td>
                          <span v-if="guest['refusal_to_pay']">Да</span>
                          <span v-else>Нет</span>
                        </td>
                        <td v-if="guest['privilege_category']">
                          Да({{getPrivilegeCateogoryCode(guest['privilege_category'])}})
                        </td>
                        <td v-if="!guest['privilege_category']">Нет</td>
                        <td>{{guest.created_at | dateFilter('DD.MM.YYYY')}}</td>
                        <td>{{guest.external_id}}</td>
                        <td v-if="reportIsActive" class="actions">
                          <router-link
                            :to="{name: 'guest-visit-edit', params: {operatorId: operatorId, visitId: guest.id}}">
                            <a class="icon"><i class="mdi mdi-edit"></i></a>
                          </router-link>
                        </td>
                        <td v-if="reportIsActive" class="actions">
                          <a href="#" class="icon" @click="deleteRecord(guest.id)"><i class="mdi mdi-delete"></i></a>
                        </td>
                      </tr>
                      <tr v-if="guestVisits && guestVisits.length>0 && !filterQuery">
                        <th></th>
                        <th><b>ИТОГО:</b></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th class="number">{{totalAmount}}</th>
                        <th>{{refusalAmount}} руб.</th>
                        <th>{{privilegeAmount}} руб.</th>
                        <th></th>
                        <th></th>
                        <th v-if="reportIsActive"></th>
                      </tr>
                      </tbody>
                    </table>
                    <div v-if="!guestVisits || guestVisits.length==0" class="text-center" style="margin-top: 20px"><h4>
                      Записей нет.</h4></div>
                    <div v-if="filteredGuestVisits.length>0 && filterQuery" class="row be-datatable-footer">
                      <div class="col-sm-6">
                        <div class="dataTables_info" id="table2_info" role="status" aria-live="polite">
                          <strong>Найдено записей: {{filteredGuestVisits.length}} из {{guestVisits.length}}</strong><br>
                        </div>
                      </div>
                    </div>
                    <div v-if="filteredGuestVisits.length===0 && filterQuery" class="text-center"
                         style="margin-top: 20px"><h4>
                      Гости с заданными параметрами поиска не найдены</h4></div>
                  </div>
                </div>
                <div v-if="guestVisits.length>0 && !filterQuery" class="row be-datatable-footer">
                  <div class="col-sm-6">
                    <div class="dataTables_info" id="table2_info" role="status" aria-live="polite">
                      <strong>Сведения о количестве лиц:</strong><br>
                      Кол-во размещенных лиц (всего): <b>{{guestVisits.length}}</b><br>
                      Кол-во лиц оплативших сбор: <b>{{countPaidGuest}}</b><br>
                      Кол-во лиц освобожденных от оплаты (льготники): <b>{{countPrivilegesGuest}}</b><br>
                      Кол-во лиц отказавшихся от оплаты: <b>{{countRefusalToPayGuest}}</b><br>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="dataTables_info" id="table2_info" role="status" aria-live="polite">
                      <strong>Сведения о суммах:</strong><br>
                      Сумма Итого: <b>{{totalAmount}} руб.</b><br>
                      Сумма льгот: <b>{{privilegeAmount}} руб.</b><br>
                      Сумма отказов: <b>{{refusalAmount}} руб.</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="operators.length ==0">
      <div class="row">
        <div class="col-md-12">
          <div class="panel">
            <div class="panel-heading panel-heading-divider">Начало работы</div>
            <div class="panel-body">
              <h4>
                Уважаемый пользователь! Список ваших операторов сбора пуст! Для начала работы необходимо добавить
                оператора.</h4>
            </div>
            <router-link :to="{name: 'operator-add'}">
              <button class="btn btn-space btn-success btn-lg pull-left">
                <i class="icon icon-left mdi mdi-plus-square"></i>
                Добавить оператора
              </button>
            </router-link>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import axios from 'axios'
  import {mapGetters, mapActions} from 'vuex'
  import DatePicker from 'vue2-datepicker'
  import {GUEST_VISITS_GET} from "../../store/actions";
  import Dashboard from '@/components/dashboard/Dashboard'

  export default {
    props: ['operatorId'],
    components: {DatePicker, Dashboard},
    data: function () {
      return {
        checkedRecords: [],
        checkAll: false,
        showModal: false,
        filterQuery: null,
        currentSort: 'last_name',
        currentSortDir: 'asc',
        selectedReport: ''
      }
    },
    created () {
      this.setCurrentOperator(this.operatorId)
      if (this.$route.query.report) {
        this.setCurrentReport(this.$route.query.report)
      }
    },
    watch: {
      checkAll () {
        if (this.checkAll) {
          this.checkedRecords = this.guestVisits
        } else {
          this.checkedRecords = []
        }
      },
      selectedReport () {
        if (this.selectedReport !== '') {
          this.$router.push({
            name: 'operator-visits',
            query: {report: this.selectedReport.id}
          })
        }
      },
      '$route': {
        deep: true,
        handler: function () {
          this.setCurrentReport(this.$route.query.report)
          if (this.$route.query.report !== this.selectedReport.id) {
            this.selectedReport = ""
          }
          this.checkedRecords = []
          this.checkAll = false
        }
      }
    },
    computed: {
      reportCanBeDeleted () {
        // Report can be deleted if report period start before 2018-05-01 or after today. Also backend check that it consist 0 records.
        return moment(this.currentReport.date_start).isBefore(moment("2018-05-01")) || moment(this.currentReport.date_start).isAfter(moment())
      },
      sortedGuestVisits: function () {
        return this.guestVisits.sort((a, b) => {
          let modifier = 1
          if (this.currentSortDir === 'desc') modifier = -1
          if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
          if (a[this.currentSort] > b[this.currentSort]) return modifier
          return 0
        })
      },
      filteredGuestVisits () {
        if (this.filterQuery) {
          let query = this.filterQuery.toLowerCase()
          let guests = this.sortedGuestVisits.filter(guest_visit => {
            let lastName = guest_visit.last_name.toLowerCase().includes(query)
            let firstName = guest_visit.first_name ? guest_visit.first_name.toLowerCase().includes(query) : null
            let middleName = guest_visit.middle_name ? guest_visit.middle_name.toLowerCase().includes(query) : null
            return (
              lastName || firstName || middleName
            )
          })
          return guests
        } else {
          return this.sortedGuestVisits
        }
      },
      reportIsActive () {
        return (this.currentReport && this.currentReport.status === 'Draft')
      },
      reportCanSubmitted () {
        return moment().isAfter(moment(this.currentReport.date_end).add(1, 'day'))
      },
      reportCanRestored () {
        let last_day = moment(this.currentReport.last_day_to_submit) // до 0.00 шестого дня
        return moment().isAfter(this.currentReport.date_end) && moment().isSameOrBefore(last_day)
      },
      buttonIsActive () {
        return this.checkedRecords.length > 0
      },
      operator () {
        return this.operators.find(op => Number(op.id) === Number(this.operatorId)) || {}
      },
      countPaidGuest () {
        let count = 0
        this.guestVisits.forEach(item => {
          if (item.tax_amount > 0) {
            count += 1
          }
        })
        return count
      },
      countRefusalToPayGuest () {
        let count = 0
        this.guestVisits.forEach(item => {
          if (item.refusal_to_pay && !item.privilege_category) {
            count += 1
          }
        })
        return count
      },
      countPrivilegesGuest () {
        let count = 0
        this.guestVisits.forEach(item => {
          if (item.privilege_category) {
            count += 1
          }
        })
        return count
      },
      totalAmount () {
        let amount = 0.00
        this.guestVisits.forEach(item => (amount += Number.parseFloat(item.tax_amount)))
        return amount
      },
      privilegeAmount () {
        let amount = 0
        this.guestVisits.forEach(item => {
          if (item.privilege_category) {
            amount += Number(item.expected_tax_amount)
          }
        })
        return amount
      },
      refusalAmount () {
        let amount = 0
        this.guestVisits.forEach(item => {
          if (item.refusal_to_pay && !item.privilege_category) {
            amount += Number(item.expected_tax_amount)
          }
        })
        return amount
      },
      ...mapGetters(
        [
          'operatorTypes',
          'legalEntityForms',
          'regions',
          'privilegeCategories',
          'operators',
          'ready',
          'reports',
          'guestVisits',
          'currentReport'
        ]
      )
    },
    methods: {
      sort: function (s) {
        //if s == current sort, reverse
        if (s === this.currentSort) {
          this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
        }
        this.currentSort = s;
      },
      downloadXls () {
        axios({
          url: '/api/generate-xls-report/' + this.currentReport.id,
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          let fileName = 'Отчет ' + this.$options.filters.dateFilter(this.currentReport.date_start, "DD.MM") + '-' + this.$options.filters.dateFilter(this.currentReport.date_end, "DD.MM.YYYY") + '(оператор №' + this.operatorId + ')' + '.xls'
          link.setAttribute('download', fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      },
      submitReport () {
        // Set report status 'Submitted'
        if (window.confirm("Внимание! После подтверждения отчетного периода, он будет закрыт для внесения изменений. Желаете подтвердить отчетный период?")) {
          this.axios.patch('/api/reports/' + this.currentReport.id + '/', {'status': 'Submitted'})
            .then((response) => {
              if (response.status === 200) {
                this.$snotify.success('Отчетный период подтверждён', 'Успешно!')
                this.getReports()
                this.currentReport.status = 'Submitted'
              }
            })
            .catch((error) => {
              if (error.response.status >= 400) {
                this.$snotify.error(error.response.data.status[0], 'Ошибка')
              }
            })
        }
      },
      restoreReport () {
        // Set report status 'Draft'
        this.axios.patch('/api/reports/' + this.currentReport.id + '/', {'status': 'Draft'})
          .then((response) => {
            if (response.status === 200) {
              this.getReports()
              this.currentReport.status = 'Draft'
            }
          })
          .catch((error) => {
            if (error.response.status >= 400) {
              this.$snotify.error(error.response.data.detail, 'Ошибка')
            }
          })
      },
      deleteReport (reportId) {
        if (window.confirm("Вы действительно хотите удалить отчетный период " + this.$options.filters.dateFilter(this.currentReport.date_start, "DD.MM") + '-' + this.$options.filters.dateFilter(this.currentReport.date_end, "DD.MM.YYYY"))) {
          this.axios.delete('/api/reports/' + reportId + '/')
            .then((response) => {
              this.$snotify.success('Отчетный период удалён.', 'Успешно!')
              this.getReports()
//              this.$router.report = this.reports[1].id
//              this.setCurrentReport(this.$router.report)
              this.$router.push({
                name: 'operator-visits',
                query: {report: reportId === this.reports[0].id ? this.reports[1].id : this.reports[0].id}
              })
            }).catch((error) => {
            if (error.response.status >= 400) {
              this.$snotify.error('Ошибка удаления отчетного периода!')
            }
          })
        }
      },
      queryGenerator (value) {
        let query = {}
        Object.assign(query, this.$route.query, value)
        return query
      },
      deleteRecord (id) {
        if (window.confirm("Удалить запись?")) {
          this.axios.delete('/api/guest_visits/' + id + '/')
            .then((response) => {
              this.$snotify.success('Запись удалена', 'Успешно!')
              this.getGuestVisits()
            }).catch((error) => {
            if (error.response.status >= 400) {
              this.$snotify.error('Ошибка удаления записи!')
            }
          })
        }
      },
      deleteCheckedRecords () {
        if (window.confirm("Вы действительно хотите удалить выделенные записи (" + this.checkedRecords.length + " шт.)?")) {
          this.axios.post('/api/guest_visits/list_delete/', this.checkedRecords)
            .then((response) => {
              this.checkedRecords = []
              this.$snotify.success('Записи удалены', 'Успешно!')
              this.getGuestVisits()
            }).catch((error) => {
            if (error.response.status >= 400) {
              this.$snotify.error('Ошибка удаления записей!')
            }
          })
        }
      },
      getNameFromDict (dictName, id) {
        return dictName.find(item => Number(item.id) === Number(id)).name
      },
      getPrivilegeCateogoryCode (id) {
        return this.privilegeCategories.find(item => Number(item.id) === Number(id)).code
      },
      get_guest_full_name (guest) {
        let lastName = guest['last_name']
        let firstName = guest['first_name'][0]
        let middleName = guest['middle_name']
        return middleName ? lastName + " ".concat(firstName) + ". ".concat(middleName[0]) + "." : lastName + " ".concat(firstName) + "."
      },
      ...mapActions([
        'getGuestVisits',
        'getReports',
        'setCurrentReport',
        'setCurrentOperator',
      ])
    }
  }
</script>
<style lang="scss">
  .opaque {
    opacity: 0.6;
  }
</style>



// WEBPACK FOOTER //
// src/components/guests/GuestVisitList.vue